const LOGIN_STATUS = {
  NONE: 'none',
  LOGOUT: 'logout',
  LOGIN: 'login'
}

const DISABLED_MODE = -1

// 改图模式 -1为未开发功能
const REDRAW_MODE = {
  DRAW: 20, // 绘图
  ZOOM: 3, // 超清放大-高清hd
  DETAIL_ENHANCER: 19, // 细节增强
  REPLACE:  0, // 改图
  RENDER: 22, // 渲染
  EDIT: 23, // 新版改图
  FLAT: 24, // 彩平图
  SPECULATION: 26, // 方案推敲
  
  TOOLKIT: 21, // 工具集-跳转
  EXPAND: DISABLED_MODE || 17, // 扩图
  HOME: 25, // 首页

  // ---------------------历史模块--------------------
  CUTOUT: 6, // 抠图
  COLOR_MIXING: DISABLED_MODE || 9, // 调色
  REMOVE_WATERMARK: DISABLED_MODE || 7, // 去水印
  ERASE: DISABLED_MODE || 1, // 擦物体
  ADD_OBJ: DISABLED_MODE || 12, // 加物体 ADD_MODEL: 14, // 加人物  合并
  BG: DISABLED_MODE || 16, // 换背景
  CHANGE_MATERIAL: DISABLED_MODE || 2, // 改材质  CHANGE_COLOR: 4, // 改颜色 -- 合并
  CHANGE_STYLE: DISABLED_MODE || 5, // 改风格
  WEATHER: DISABLED_MODE || 15, // 调天气 11
  LIGHT: DISABLED_MODE, // 调光线
  CLIP: DISABLED_MODE || 10, // 裁剪
  ADD_WATERMARK: DISABLED_MODE || 8, // 加水印
  SMART_MARK: DISABLED_MODE || 13, // 标注 
}

// 用户权益 work_type（工作类型：1-溜溜ai 2-ai渲染 3-改图 4-彩平图 5-PS插件）
const REDRAW_MODE_WORK_TYPE: any = {
  [REDRAW_MODE.DRAW]: 1, // 绘图 -> 溜溜ai
  [REDRAW_MODE.ZOOM]: 1, // 超清放大-高清hd -> 溜溜ai
  [REDRAW_MODE.DETAIL_ENHANCER]: 1, // 细节增强 -> 溜溜ai
  [REDRAW_MODE.REPLACE]: 1, // 改图 -> 溜溜ai
  [REDRAW_MODE.RENDER]: 2, // 渲染 -> ai渲染
  [REDRAW_MODE.EDIT]: 3, // 新版改图 -> 改图
  [REDRAW_MODE.FLAT]: 4, // 彩平图 -> 平面填彩
}


//模式对应的名称
const REDRAW_NAME = {
  [REDRAW_MODE.DRAW]: '生图',
  [REDRAW_MODE.REPLACE]: '改图',
  [REDRAW_MODE.DETAIL_ENHANCER]: '细节增强',
  [REDRAW_MODE.ZOOM]: '高清HD',
  [REDRAW_MODE.RENDER]: 'AI渲染',
  [REDRAW_MODE.EDIT]: 'AI改图',
  [REDRAW_MODE.FLAT]: '平面填彩',
  [REDRAW_MODE.HOME]: '首页',
}

// 有画布的模式
const HAS_CANVAS_MODES = [
  REDRAW_MODE.REPLACE,
  // REDRAW_MODE.DETAIL_ENHANCER,
]
// 改图工具条
const TOOLBAR = {
  AI_PAINT: 'ai-paint', // AI选区-选择
  AI_REMOVE: 'ai-remove', // AI选区-取消选择
  MANU_PAINT: 'manu-paint', // 手动涂抹
  ERASE: 'erase', // 橡皮擦
  MANUAL_PICK: 'manual-pick', // 抠图 手动 + 擦除
  MANUAL_CLEAR: 'manual-clear', // 抠图 手动 + 保留
  AI_PICK: 'ai-pick', // 抠图 自动 + 擦除
  AI_CLEAR: 'ai-clear', // 抠图 自动 + 保留
  NONE: 'none' // 无
}


// 改图working状态
const WORKING_STATUS = {
  START: 'start', // 开始状态(发起改图接口时候)
  QUENING: 'quening', // 排队中
  DOING: 'doing', // 创作中
  WAITING: 'waiting', // 等待状态(创作超过了3s)
  DONE: 'done' // 已完成
}

const AUTO_AREA_TYPE = 1 // 自动涂抹类型
const MANUAL_AREA_TYPE = 2 // 手动涂抹类型
const HOVER_AREA_TYPE = 3 // 鼠标悬浮涂抹类型
const CLEAR_AREA_TYPE = 4 // 橡皮擦擦除类型
const CUTOUT_AI_CACHU = 5 // 抠图 AI 擦除
const CUTOUT_AI_BAOLIU = 6 // 抠图 AI 保留
const CUTOUT_AI_BG = 7 // 抠图 AI 智能去背景
// AUTO_AREA_TYPE | MANUAL_AREA_TYPE | HOVER_AREA_TYPE | CLEAR_AREA_TYPE | CUTOUT_AI_CACHU | CUTOUT_AI_BAOLIU
type AreaType = 1 | 2 | 3 | 4 | 5 | 6 | 7

const AUTO_PAINT = 'auto-paint'
const MIXED_DATA = 'mixed-data'

const CTRL_WHEEL = {
  SCALE_MODE: 0,
  PENCIL_MODE: 1,
  ERASER_MODE: 2
}

const aiAreaTypeMap = {
  [TOOLBAR.AI_CLEAR]: CUTOUT_AI_BAOLIU,
  [TOOLBAR.AI_PICK]: CUTOUT_AI_CACHU,
  default: AUTO_AREA_TYPE,
  [TOOLBAR.AI_REMOVE]: CUTOUT_AI_BAOLIU,
}

// canvas resize mode
const canvasResize = {
  CONTRAST: 0, // 切换底部小图、查看比对
  SHOW_BOTTOM_LIST: 1, // 显示底部小图列表，场景：非擦除物体模式下改图进行中
  SHOW_BOTTOM_LIST_AND_TOOLBOX: 2, // 显示底部小图列表(非擦除物体模式)和顶部图片工具箱，场景：改图完成时、切换保存记录图片
  HIDE_BOTTOM_LIST_AND_TOOLBOX: 3, // 不显示底部小图列表和顶部图片工具箱，场景：重新上传图片、复制指令
  CLIP: 4
}

const CANVAS_IMAGE_ACTION = {
  INIT: 'init',
  COPY: 'copy',
  CLEAR: 'clear',
  FILL: 'fill',
  RESET: 'reset'
}
const WATERMARK_STYLE = {
  IMAGE: 1,
  TEXT: 2,
  INTERNAL_TEXT1: 3,
  INTERNAL_TEXT2: 4,
  INTERNAL_TEXT3: 5
}

const BRUSH_MODE = {
  PAINT: 'paint',
  ERASE: 'erase'
}
const DEFAULT_PENCIL_SIZE = 50

const BRUSH_TOOL = {
  PENCIL: 'pencil', // 画笔
  CIRCLE: 'circle', // 圆形
  RECT: 'rect',     // 矩形
  LINE: 'line',     // 直线
  LASSO: 'lasso'    // 套索
};

// export type BrushToolType = typeof BRUSH_TOOL;

// 标注类型
const MARK_TYPE: any = {
  structure: 1,
  text: 2,
  screen: 3,
  floor: 4,
  av: 5
}
// 标注类型对应的标注内容text
const MARK_CONTENT_TEXT: any = {
  1: '结构',
  2: '文字',
  3: '画面',
  4: '地面',
  5: 'AV'
}
// 标注类型对应的标注内容
const MARK_CONTENT_LIST: any = {
  1: ['防火板', '涂料', '烤漆', '贴纸', '挂板', '铝明板', '软膜', '绷布'],
  2: ['亚克力发光字', '不锈钢包边发光字', '阴刻发光字', '吸塑发光字', '树脂发光字', '即时贴字', '亚克力字', '雪弗板字', '金属字'],
  3: ['写真', '侧发光写真', '灯片发光灯箱', '软膜发光灯箱', '亚克力发光灯箱', '地贴'],
  4: ['三聚氰胺板', '淋油板', '复合地板', '玻璃地台', '拉绒地毯', '圈绒地毯', '割绒地毯'],
  5: ['LED拼屏', 'LED电视', '冰屏', '彩幕', 'LED灯带', '亚克力发光灯带']
}
// 标注类型对应的标注内容主题色
const MARK_CONTENT_COLOR: any = {
  1: '#E8698F',
  2: '#FD8B6D',
  3: '#FBC251',
  4: '#9EDBDE',
  5: '#B9C7F4'
}

const DEFAULT_IMAGE_ORIGINAL_SIZE = [0,0]

const ADID_IMAGEURL_MAP:any = {
  1: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750239151310.jpg',
  2: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750238976087.jpg',
  3: 'https://imgo.3d66.com/ai/reference_image/202507/179175740_1751534689991.png',
  4: 'https://imgo.3d66.com/ai/reference_image/202507/179175740_1751453611758.png',
  5: 'https://imgo.3d66.com/ai/reference_image/202507/179175740_1751613851807.png',
  6: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750300799254.jpg',
  7: 'https://imgo.3d66.com/ai/reference_image/202507/179175740_1751618003450.png',
  8: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750239180458.jpg',
  9: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750238941441.jpg',
  10: 'https://imgo.3d66.com/ai/reference_image/202506/179175740_1750239089876.jpg',
}

const reDrawModeMappingCopyName = {
  [REDRAW_MODE.DRAW]:{name:'画同款'},
  [REDRAW_MODE.ZOOM]:{name:'复制指令'},
  [REDRAW_MODE.REPLACE]:{name:'复制指令'},
  [REDRAW_MODE.DETAIL_ENHANCER]:{name:'复制指令'}
}

const ECreativeType = {
  JZHY:0, //精准还原
  JBHY:1, //局部还原
  LGFS:2, //灵感发散
  ZYCZ:3  //自由创作
}

const CreativeType = [
  {name:'精准还原',value:0,des:'保留原结构，添加材质，光线细节，优化渲染细节~',title:'95%精准还原'},
  {name:'局部还原',value:1,des:'保留原结构，添加空间元素，优化整体布局~',title:'90%局部还原'},
  {name:'灵感发散',value:2,des:'微调原结构，提供多样化的设计元素~',title:'70%灵感发散'},
  {name:'自由创作',value:3,des:'突破原结构，自由发挥创造，激发灵感~',title:'40%自由创造'},
]


const DRAW_EXAMPLE_PIC_MAP:any = {
  1: 'https://imgo.3d66.com//ai/reference_image/202510/179959930_1761728791036.png',
  2: 'https://imgo.3d66.com//ai/reference_image/202510/179959930_1761728804798.jpg',
  3: 'https://imgo.3d66.com//ai/reference_image/202510/179959930_1761728809117.png'
}

// 过期-废弃
// const DRAW_EXAMPLE_PIC_MAP_TEST:any = {
//   1: 'https://3d66.oss-cn-hangzhou.aliyuncs.com/aiim/test/178889882_1761728645447.png',
//   2: 'https://3d66.oss-cn-hangzhou.aliyuncs.com/aiim/test/178889882_1761728689235.jpg',
//   3: 'https://3d66.oss-cn-hangzhou.aliyuncs.com/aiim/test/178889882_1761728722210.png'
// }


// ps曝光引流id列表
const PS_DRAINAGE_IDS = [98]


export {
  REDRAW_MODE,
  TOOLBAR,
  WORKING_STATUS,
  AUTO_AREA_TYPE,
  MANUAL_AREA_TYPE,
  HOVER_AREA_TYPE,
  CLEAR_AREA_TYPE,
  CUTOUT_AI_CACHU,
  CUTOUT_AI_BAOLIU,
  CUTOUT_AI_BG,
  AUTO_PAINT,
  MIXED_DATA,
  CTRL_WHEEL,
  aiAreaTypeMap,
  type AreaType,
  canvasResize,
  CANVAS_IMAGE_ACTION,
  WATERMARK_STYLE,
  BRUSH_MODE,
  BRUSH_TOOL,
  MARK_TYPE,
  MARK_CONTENT_TEXT,
  MARK_CONTENT_LIST,
  MARK_CONTENT_COLOR,
  DISABLED_MODE,
  REDRAW_NAME,
  DEFAULT_IMAGE_ORIGINAL_SIZE,
  ADID_IMAGEURL_MAP,
  reDrawModeMappingCopyName,
  ECreativeType,
  CreativeType,
  LOGIN_STATUS,
  DEFAULT_PENCIL_SIZE,
  HAS_CANVAS_MODES,
  DRAW_EXAMPLE_PIC_MAP,
  // DRAW_EXAMPLE_PIC_MAP_TEST
  PS_DRAINAGE_IDS,
  REDRAW_MODE_WORK_TYPE,
}
